'use client';

import React from 'react';
import Image from '@/components/atoms/Image';
import { ArrowLongRightIcon as ArrowIcon } from '@heroicons/react/24/solid';
import Link from '@/components/atoms/link';
import { ContentTileProps } from './types';

const ContentTile = ({ title, link, image, imageSizes }: ContentTileProps) => {
  return (
    <div>
      <Link href={link?.href ?? '#'} openInNewTab={link?.openInNewTab} className="relative block w-full pb-[85%]">
        <Image
          {...image}
          fill
          style={{ objectFit: 'cover' }}
          sizes={imageSizes}
          alt={title ?? ''}
          className="rounded-md"
        />
      </Link>
      <Link
        href={link?.href ?? '#'}
        openInNewTab={link?.openInNewTab}
        underlineOnHover={false}
        className="text-16 lg:text-18 mt-4 block py-1 leading-normal font-bold text-gray-700"
      >
        {title}
      </Link>
      <Link
        href={link?.href ?? '#'}
        openInNewTab={link?.openInNewTab}
        className="text-14 lg:text-16 mt-3 flex items-center gap-2 py-1 leading-normal text-gray-700"
      >
        <span className="hidden lg:block">{link?.name}</span>
        <ArrowIcon className="text-gray-700" width={20} />
      </Link>
    </div>
  );
};

export default ContentTile;
